import * as BX from "main";
import {Reflection, Type} from 'main.core';

const namespace = Reflection.namespace('BX.Citrus.Aproduction3.Catalog.Element');

export class Tabs {
    constructor() {
        this.activeIndex = null;

        BX.ready(() => this.onReady());
        if (!Tabs.init)
        {
            Tabs.init = true;
            BX.addCustomEvent('onComponentAjaxHistorySetState', () => this.onReady());
        }
    }

    getCount() {
        return $('.b-tabs__content_desktop').length;
    }

    /**
     *
     * @param {int} index
     * @param callback animation done callback
     */
    setActive(index, callback = undefined) {
        const $tabLinks = $('.b-tabs__header > .b-tabs__link');
        const $tabContents = $('.b-tabs__content_desktop');
        const $tabLinkActive = $tabLinks.eq(index);

        $tabLinks.removeClass('b-tabs__link_active');
        $tabLinkActive.addClass('b-tabs__link_active');

        $tabContents.removeClass('b-tabs__content_active');
        $tabContents.eq(index).addClass('b-tabs__content_active');

        this.setActiveMobile(index, callback);
    }

    setActiveMobile(index, callback) {
        const $tabLinksMobile = $('.b-tabs__link_mobile');
        const $tabLinksMobileActive = $tabLinksMobile.eq(index);

        const isActiveAlready = $tabLinksMobileActive.hasClass('b-tabs__link_active');

        $tabLinksMobile.removeClass('b-tabs__link_active')
            .children('.b-tabs__icon')
            .removeClass('b-tabs__icon_active')
            .children('.fa')
            .removeClass('fa-angle-down')
            .addClass('fa-angle-right');
        $tabLinksMobile.siblings().removeClass('b-tabs__content_active').slideUp('fast');

        this.activeIndex = null;
        if (!isActiveAlready) {
            $tabLinksMobileActive.addClass('b-tabs__link_active')
                .children('.b-tabs__icon')
                .addClass('b-tabs__icon_active')
                .children('.fa')
                .addClass('fa-angle-down')
                .removeClass('fa-angle-right');

            $tabLinksMobileActive.siblings().addClass('b-tabs__content_active').slideDown('fast', callback);
            this.activeIndex = index;
        }
    }

    getTabIndex(tab) {
        const $tab = $(tab);
        if ($tab.is('.b-tabs__link_mobile')) {
            const $mobileTabs = $('.b-tabs__link_mobile');
            return $mobileTabs.index($tab);
        }
        return $tab.index();
    }

    onReady() {
        $('.b-tabs__link_desktop').on('click', (event) => {
            event.preventDefault();
            this.setActive(this.getTabIndex(event.target));
        });
        this.setActive(0);

        $('.b-tabs__link_mobile').on('click', (event) => {
            event.preventDefault();

            const $tabLink = $(event.target).closest('.b-tabs__link_mobile');
            this.setActive(this.getTabIndex($tabLink));
        });
    }

}

namespace.Tabs = Tabs;
